import React from "react";

const EditPageLoader = () => {
  return (
    <div className="containerMain animate-pulse flex flex-col gap-8 p-6 min-h-screen">
      {/* Başlık */}
      <div className="h-8 w-1/4 bg-gray-100 rounded-2xl" />

      {/* Grid Düzeni */}
      <div className="grid grid-cols-1 md:grid-cols-[248px_1fr] gap-6 min-h-[1200px]">
        {/* Sol Alan (ImageUpload) */}
        <div className="left-area flex flex-col gap-8">
          <div className="bg-gray-100 rounded-2xl h-[400px]" />
        </div>

        {/* Sağ Alan */}
        <div className="right-area flex flex-col gap-8">
          {/* ProjectDetails */}
          <div className="bg-gray-100 rounded-2xl h-[400px]" />

          {/* OpenPositions */}
          <div className="bg-gray-100 rounded-2xl h-[600px]" />

          {/* NewPositions */}
          <div className="bg-gray-100 rounded-2xl h-[400px]" />

          {/* TeamMembers */}
          <div className="bg-gray-100 rounded-2xl h-[300px]" />

          {/* ProjectActions */}
          <div className="flex justify-end">
            <div className="h-12 w-40 bg-gray-100 rounded-2xl" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPageLoader;
